/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

import moveEntityTemplate from '../admin/entity/move-entity.tpl.html';
import copyEntityTemplate from '../admin/entity/copy-entity.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

import MoveEntityController from '../admin/entity/move-entity.controller';
import CopyEntityController from '../admin/entity/copy-entity.controller';

export default angular.module('agrolog.api.silo', [])
    .factory('siloService', SiloService)
    .name;

/*@ngInject*/
function SiloService($q, $mdDialog, $document, $filter, types, agTypes, agUserService, entityService, alarmService) {

    var allSiloAttributesKeys = [];
    var allSensorLinesServerAttributesKeys = [];
    var allSensorLinesClientAttributesKeys = [];
    var allLevelIndicatorServerAttributes = [];
    var allLevelIndicatorClientAttributes = [];

    for (var attrId in agTypes.attributes.baseAsset) {
        var attr = agTypes.attributes.baseAsset[attrId];
        allSiloAttributesKeys.push(attr);
    }

    for (attrId in agTypes.attributes.silo) {
        attr = agTypes.attributes.silo[attrId];
        allSiloAttributesKeys.push(attr);
    }

    for (attrId in agTypes.attributes.temperatureSensorLinesServer) {
        attr = agTypes.attributes.temperatureSensorLinesServer[attrId];
        allSensorLinesServerAttributesKeys.push(attr);
    }

    for (attrId in agTypes.attributes.temperatureSensorLinesClient) {
        attr = agTypes.attributes.temperatureSensorLinesClient[attrId];
        allSensorLinesClientAttributesKeys.push(attr);
    }

    for (attrId in agTypes.attributes.levelIndicatorServer) {
        attr = agTypes.attributes.levelIndicatorServer[attrId];
        allLevelIndicatorServerAttributes.push(attr);
    }

    for (attrId in agTypes.attributes.levelIndicatorClient) {
        attr = agTypes.attributes.levelIndicatorClient[attrId];
        allLevelIndicatorClientAttributes.push(attr);
    }


    var positionAttributeKeys = [];
    positionAttributeKeys.push(agTypes.attributes.baseAsset.positionX);
    positionAttributeKeys.push(agTypes.attributes.baseAsset.positionY);

    var service = {
        saveSilo: saveSilo,
        copySilo: copySilo,
        copySiloDialog: copySiloDialog,
        moveSiloDialog: moveSiloDialog,
        getSilo: getSilo,
        getSiloDevices: getSiloDevices,
        getSiloSensorLines: getSiloSensorLines,
        getSiloLevelIndicator: getSiloLevelIndicator,
        getSiloHeadSpaceSensor: getSiloHeadSpaceSensor,
        deleteSilo: deleteSilo,
        getSiloConnectedSystems: getSiloConnectedSystems,
        getMapSiloConnectedSystems: getMapSiloConnectedSystems,
        excludeUnconnectedSensorLines: excludeUnconnectedSensorLines
    }

    return service;

    function saveSilo(silo, parentEntityId) {
        var deferred = $q.defer();
        var assign = !silo.id.id;
        entityService.saveRelatedEntity(silo, parentEntityId, allSiloAttributesKeys).then(
            function success(silo) {
                if (assign) {
                    agUserService.assignAssetToCustomer(silo).then(
                        (silo) => {
                            deferred.resolve(silo);
                        },
                        () => {
                            deferred.reject();
                        }
                    );
                } else {
                    deferred.resolve(silo);
                }
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function copySilo(silo, targetEntityId) {
        var deferred = $q.defer();
        entityService.copyEntity(silo, targetEntityId, allSiloAttributesKeys).then(
            function success(silo) {
                agUserService.assignAssetToCustomer(silo).then(
                    (silo) => {
                        deferred.resolve(silo);
                    },
                    () => {
                        deferred.reject();
                    }
                );
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function copySiloDialog($event, silo) {
        var deferred = $q.defer();
        if ($event) {
            $event.stopPropagation();
        }
        var placeholderText = 'ag.silo.select-copy-target-text';
        var notFoundText = 'ag.silo.copy-target-not-found-text';
        var requiredText = 'ag.silo.copy-target-requited-text';
        var targetEntitySubtypes = [agTypes.assetType.site, agTypes.assetType.siloGroup];
        var newEntityNameText = 'ag.silo.new-silo-name';
        var newEntityNameRequiredText = 'ag.silo.new-silo-name-required';

        agUserService.getAgrologCustomer().then(
            (agCustomer) => {
                var targetRootEntityId = agCustomer.id;
                $mdDialog.show({
                    controller: CopyEntityController,
                    controllerAs: 'vm',
                    templateUrl: copyEntityTemplate,
                    parent: angular.element($document[0].body),
                    locals: {
                        placeholderText: placeholderText,
                        notFoundText: notFoundText,
                        requiredText: requiredText,
                        entity: angular.copy(silo),
                        targetRootEntityId: targetRootEntityId,
                        targetEntityType: types.entityType.asset,
                        targetEntitySubtypes: targetEntitySubtypes,
                        newEntityNameText: newEntityNameText,
                        newEntityNameRequiredText: newEntityNameRequiredText
                    },
                    fullscreen: true,
                    targetEvent: $event
                }).then(function () {
                    deferred.resolve();
                }, function () {
                    deferred.reject();
                });
            },
            () => {
                deferred.reject();
            }
        );

        return deferred.promise;
    }

    function moveSiloDialog($event, silo, parentEntityId) {
        var deferred = $q.defer();
        if ($event) {
            $event.stopPropagation();
        }

        var placeholderText = 'ag.silo.select-move-target-text';
        var notFoundText = 'ag.silo.move-target-not-found-text';
        var requiredText = 'ag.silo.move-target-requited-text';
        var targetEntitySubtypes = [agTypes.assetType.site, agTypes.assetType.siloGroup];

        agUserService.getAgrologCustomer().then(
            (agCustomer) => {
                var targetRootEntityId = agCustomer.id;
                $mdDialog.show({
                    controller: MoveEntityController,
                    controllerAs: 'vm',
                    templateUrl: moveEntityTemplate,
                    parent: angular.element($document[0].body),
                    locals: {
                        placeholderText: placeholderText,
                        notFoundText: notFoundText,
                        requiredText: requiredText,
                        parentEntityId: parentEntityId,
                        entity: silo,
                        targetRootEntityId: targetRootEntityId,
                        targetEntityType: types.entityType.asset,
                        targetEntitySubtypes: targetEntitySubtypes
                    },
                    fullscreen: true,
                    targetEvent: $event
                }).then(function () {
                    deferred.resolve();
                }, function () {
                    deferred.reject();
                });
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getSilo(siloId) {
        var deferred = $q.defer();
        entityService.getRelatedEntity(siloId, allSiloAttributesKeys, agTypes.assetTypeTranslatePrefix).then(
            function success(silo) {
                deferred.resolve(silo);
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getSiloDevices(siloId) {
        var deferred = $q.defer();
        entityService.getRelatedEntities(siloId, types.entityType.device,
            [agTypes.deviceType.temperatureSensorLines, agTypes.deviceType.moistureSensorLines, agTypes.deviceType.co2SensorLines,
                agTypes.deviceType.levelIndicator, agTypes.deviceType.headSpaceSensor], 1, [], agTypes.deviceTypeTranslatePrefix).then(
            function success(devices) {
                deferred.resolve(devices);
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getSiloSensorLines(siloId) {
        var deferred = $q.defer();
        entityService.getRelatedEntities(siloId, types.entityType.device,
            [agTypes.deviceType.temperatureSensorLines, agTypes.deviceType.moistureSensorLines, agTypes.deviceType.co2SensorLines], 1,
            allSensorLinesServerAttributesKeys, agTypes.deviceTypeTranslatePrefix, null, null, allSensorLinesClientAttributesKeys).then(
            function success(devices) {
                deferred.resolve(devices);
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getSiloLevelIndicator(siloId) {
        var deferred = $q.defer();
        entityService.getRelatedEntities(siloId, types.entityType.device,
            [agTypes.deviceType.levelIndicator], 1, allLevelIndicatorServerAttributes, agTypes.deviceTypeTranslatePrefix, null, null, allLevelIndicatorClientAttributes).then(
            function success(devices) {
                deferred.resolve(devices);
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getSiloHeadSpaceSensor(siloId) {
        var deferred = $q.defer();
        entityService.getRelatedEntities(siloId, types.entityType.device,
            [agTypes.deviceType.headSpaceSensor, agTypes.deviceType.headSpaceSensor2000], 1, [], agTypes.deviceTypeTranslatePrefix).then(
            function success(devices) {
                deferred.resolve(devices);
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function deleteSilo(siloId) {
        var deferred = $q.defer();
        entityService.deleteRelatedEntity(siloId).then(
            function success() {
                deferred.resolve();
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getSiloConnectedSystems(siloId, fetchAlarmsSeverity) {
        return fetchSiloConnectedSystems(siloId, [agTypes.attributes.aeration.aerationType], fetchAlarmsSeverity);
    }

    function getMapSiloConnectedSystems(siloId, fetchAlarmsSeverity) {
        return fetchSiloConnectedSystems(siloId, positionAttributeKeys, fetchAlarmsSeverity);
    }

    function fetchSiloConnectedSystems(siloId, keys, fetchAlarmsSeverity) {
        var deferred = $q.defer();
        entityService.getRelatedEntities(siloId, types.entityType.asset, [agTypes.assetType.aeration], 1, keys,
            agTypes.assetTypeTranslatePrefix, agTypes.relationType.aerationSystem, types.entitySearchDirection.to).then(
            function success(connectedSystems) {
                if (fetchAlarmsSeverity) {
                    var alarmsSeverityTasks = [];
                    for (var i=0;i<connectedSystems.length;i++) {
                        var connectedSystem = connectedSystems[i];
                        alarmsSeverityTasks.push(fetchConnectedSystemsAlarmSeverity(connectedSystem));
                    }
                    $q.all(alarmsSeverityTasks).then(
                        function success(siteAssets) {
                            deferred.resolve(siteAssets);
                        },
                        function fail() {
                            deferred.reject();
                        }
                    );
                } else {
                    deferred.resolve(connectedSystems);
                }
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function fetchConnectedSystemsAlarmSeverity(connectedSystem) {
        var deferred = $q.defer();
        alarmService.getAlarms(connectedSystem.id.entityType, connectedSystem.id.id, {limit: 1000}, null, types.alarmStatus.activeUnack, true).then(
            (alarmsObj) => {
                let res = $filter('filter')(alarmsObj.data, {originator: { id: connectedSystem.id.id } });
                if (res.length) {
                    connectedSystem.highestAlarmSeverity = 'CRITICAL';
                    connectedSystem.highestAlarmStatus = types.alarmStatus.activeUnack;
                }
                deferred.resolve(connectedSystem);
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function excludeUnconnectedSensorLines(sensorLines) {
        for (var i = sensorLines.length - 1; i >= 0; --i) {
            if(!sensorLines[i][agTypes.attributes.temperatureSensorLinesClient.lineNum] ||
                !sensorLines[i][agTypes.attributes.temperatureSensorLinesClient.sensorCount] ) {
                sensorLines.splice(i, 1);
            }
        }
        return sensorLines;
    }
}
